import React from 'react';
import { history } from 'store';
import IntlMessages from 'util/IntlMessages';
import ContainerHeader from 'components/ContainerHeader';
import Collapsible from 'react-collapsible';
import ListItem from './Components/ListItem';
import Distribution from './Components/Distribution';
import DimensionTable from './Components/DimensionTable';
import { expectationsData } from './Components/Data/expectationsData';

export class Component extends React.Component {
    constructor() {
        super();
    }

    state = {
        topResultsTableData: [],
    };

    counter = 0;

    componentDidMount() {
        const { showOrgSurveyLoader, fetchOrgSurveysEngagementReportChartData } = this.props;
        showOrgSurveyLoader();
        fetchOrgSurveysEngagementReportChartData();
    }

    componentDidUpdate(prevProps) {
        // TODO - move these to separate services
        const { orgSurveyCompareTopResultsChartData, orgSurveyCompareBottomResultsChartData, orgSurveyCompareDistributionsChartData } = this.props;
        if (orgSurveyCompareTopResultsChartData !== prevProps.orgSurveyCompareTopResultsChartData) {
            const newTopResultsDataSet = orgSurveyCompareTopResultsChartData.map((results) => {
                return results.map((entry) => {
                    console.log('top result entry '.concat(JSON.stringify(entry)));
                    const answeredCount = entry?.values?.answeredCount > 0 ? entry?.values?.answeredCount : 1;
                    const perceptionData = [
                        entry?.engagementData?.activelyDisengaged > 0 ? (entry?.engagementData?.activelyDisengaged / answeredCount) * 100 : 0,
                        entry?.engagementData?.passive > 0 ? (entry?.engagementData?.passive / answeredCount) * 100 : 0,
                        entry?.engagementData?.moderatelyEngaged > 0 ? (entry?.engagementData?.moderatelyEngaged / answeredCount) * 100 : 0,
                        entry?.engagementData?.highlyEngaged > 0 ? (entry?.engagementData?.highlyEngaged / answeredCount) * 100 : 0,
                    ];
                    const data = this.createData(entry.id, entry.question, perceptionData, '---');
                    console.log('top result '.concat(JSON.stringify(data)));
                    return data;
                });
            });
            this.setState({ topResultsTableData: newTopResultsDataSet });
        }
        if (orgSurveyCompareBottomResultsChartData !== prevProps.orgSurveyCompareBottomResultsChartData) {
            const newBottomResultsDataSet = orgSurveyCompareBottomResultsChartData.map((results) => {
                return results.map((entry) => {
                    console.log('bottom result entry '.concat(JSON.stringify(entry)));
                    const answeredCount = entry?.values?.answeredCount > 0 ? entry?.values?.answeredCount : 1;
                    const perceptionData = [
                        entry?.engagementData?.activelyDisengaged > 0 ? (entry?.engagementData?.activelyDisengaged / answeredCount) * 100 : 0,
                        entry?.engagementData?.passive > 0 ? (entry?.engagementData?.passive / answeredCount) * 100 : 0,
                        entry?.engagementData?.moderatelyEngaged > 0 ? (entry?.engagementData?.moderatelyEngaged / answeredCount) * 100 : 0,
                        entry?.engagementData?.highlyEngaged > 0 ? (entry?.engagementData?.highlyEngaged / answeredCount) * 100 : 0,
                    ];
                    const data = this.createData(entry.id, entry.question, perceptionData, '---');
                    console.log('bottom result '.concat(JSON.stringify(data)));
                    return data;
                });
            });
            this.setState({ bottomResultsTableData: newBottomResultsDataSet });
        }
        if (orgSurveyCompareDistributionsChartData !== prevProps.orgSurveyCompareDistributionsChartData) {
            this.setState({ distributionChartData: orgSurveyCompareDistributionsChartData });
        }
    }

    onBackToCompare = () => {
        history.push('/app/org-survey-compare/default');
    };

    createData(grouping, question, perceptionData, shift) {
        this.counter += 1;
        return { id: this.counter, grouping, question, perceptionData, shift };
    }

    render() {
        const { topResultsTableData, bottomResultsTableData, distributionChartData } = this.state;
        return (
            <div>
                <div className="col-md-12 col-sm-12 col-12 animation slideInRight">
                    <div className="p-4">
                        <Collapsible trigger={<IntlMessages id="engagement.survey.results.expectations" />}>
                            <div className="animated slideInUpTiny animation-duration-3">
                                {expectationsData.map((data, index) => (
                                    <ListItem key={index} data={data} styleName="card-strip" />
                                ))}
                            </div>
                        </Collapsible>
                    </div>
                </div>
                <div className="col-md-12 col-sm-12 col-12 animation slideInRight">
                    <ContainerHeader title={<IntlMessages id="engagement.survey.results.comparison" />} />
                    <div className="card p-4">
                        <div className="row">
                            <Distribution distributionData={distributionChartData} />
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-sm-12 col-12 animation slideInRight">
                    <ContainerHeader title={<IntlMessages id="engagement.survey.results.top" />} />
                    <div className="card p-4">
                        {Array.isArray(topResultsTableData)
                            ? topResultsTableData.map((topResult, index) => {
                                  return <DimensionTable key={index} data={topResult} />;
                              })
                            : null}
                        ;
                    </div>
                </div>
                <div className="col-md-12 col-sm-12 col-12 animation slideInRight">
                    <ContainerHeader title={<IntlMessages id="engagement.survey.results.bottom" />} />
                    <div className="card p-4">
                        <DimensionTable data={bottomResultsTableData} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Component.js